import { BaseSerializer } from "./baseSerializer.ts";

import { ScheduleSegment } from "@models/ScheduleSegment.model.ts";
import { toUtcStartOfDay, toUtcEndOfDay, utcDateToLocalMidnight } from "../../utils/date-utils/scheduleDate.ts";

export class ScheduleSegmentSerializer extends BaseSerializer {
  public deserialize(data: any): ScheduleSegment {
    const gp = new ScheduleSegment();
    this._copyAttributes(gp, data);
    gp.start_time = utcDateToLocalMidnight(gp.start_time)
    gp.end_time = utcDateToLocalMidnight(gp.end_time)
    return gp;
  }

  // Date-only fields are pinned to UTC day boundaries so the backend's UTC range covers the whole day.
  public serialize(segment: Partial<ScheduleSegment>): string {
    const payload: any = { ...segment };
    if (segment.start_time != null) payload.start_time = toUtcStartOfDay(segment.start_time);
    if (segment.end_time != null) payload.end_time = toUtcEndOfDay(segment.end_time);
    return JSON.stringify(payload);
  }
}
